import Vue from 'vue'
import VueI18n from 'vue-i18n'
// 引入 Element 官方语言包
import elementEn from 'element-ui/lib/locale/lang/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
// 引入自定义语言包
import customEn from '../locales/en'
import customZh from '../locales/zh-CN'

Vue.use(VueI18n)

// 合并 Element 和自定义语言包
const messages = {
  en: {
    ...elementEn,  // 展开 Element 英文翻译
    ...customEn    // 展开自定义英文翻译
  },
  'zh-CN': {
    ...elementZh,  // 展开 Element 中文翻译
    ...customZh    // 展开自定义中文翻译
  }
}

// 创建 i18n 实例，默认语言为中文
const i18n = new VueI18n({
  locale: 'zh-CN',
  messages
})

export default i18n
